import { FormState } from '../../state/form.state';
import { loadHistoricalValuesFromBackendSuccess } from '../../actions/historical-values.actions';
import { on } from '@ngrx/store';
import { HistoricalValue } from '../../../types/historical-value';

export function loadHistoricalValuesFromBackendSuccessReducer(
    state: Readonly<FormState>,
    props: {
        historicalValues: HistoricalValue[];
    },
): Readonly<FormState> {
    const combinedHistoricalValues = [...state.historicalValues, ...props.historicalValues];

    const uniqueArray = [...new Map(combinedHistoricalValues.map((item) => [item.id, item])).values()];

    return {
        ...state,
        historicalValues: uniqueArray,
    };
}

export const historicalValuesReducer = [
    on<FormState, Array<typeof loadHistoricalValuesFromBackendSuccess>>(
        loadHistoricalValuesFromBackendSuccess,
        loadHistoricalValuesFromBackendSuccessReducer,
    ),
];
